import { Component, OnInit, OnDestroy, ViewChild, Output, EventEmitter, ChangeDetectorRef, Input, AfterViewChecked } from '@angular/core';
import { Client, Booking } from '../../models';
import { ClientService, SalonService } from '../../services';
import { List } from 'immutable';
import { ClientPickerComponent } from '../../components/smr-client-picker/smr-client-picker.component';
import {
  ActionSheetController,
  AlertController,
  ModalController,
  LoadingController,
  Platform
} from '@ionic/angular';
// import { FileOpener } from '@awesome-cordova-plugins/file-opener';
import { Utilities } from '../../utilities/utilities';
import { ClientFormPageComponent } from '../../components/client-form-page/client-form-page.component';
import { ClientMergeComponent } from '../../components/client-merge/client-merge.component';
import { Router } from '@angular/router';
import { Location } from "@angular/common";
import { NavigationStateService } from '../../services/navigation-state.service';
export interface IClientFormCallBackData {
  client: Client;
  action: string;
}
@Component({
  selector: 'smr-client-detail',
  templateUrl: './client-detail.page.html',
  styleUrls: ['./client-detail.page.scss'],
})
export class ClientDetailPage implements OnInit, AfterViewChecked, OnDestroy {

  @Output() clientLoaded = new EventEmitter<Client>();
  @Output() clientEdited = new EventEmitter<Client>();

  @Output() clientDeleted: EventEmitter<number> = new EventEmitter<number>();

  @Output() clientMerged = new EventEmitter<Client>();
  @Output() profilePhoto = new EventEmitter<any>();

  @ViewChild(ClientPickerComponent) clientPickerComponent: ClientPickerComponent;
  public clientID: number;
  @Input() client: Client;
  public bookingID;


  public isLoading: boolean;

  public errorOccurredWhileLoadingClientDetails: boolean;

  public clientFormPromise: Function;

  public tab: string;

  public isLoadingPastBookings: boolean;

  public errorOccurredWhileLoadingPastBookings: boolean;

  public pastBookings: List<Booking> = List([]);

  public windowWidth

  public firstLoaded: boolean = true;

  public subscriptions;

  public navigationStateSubscription;

  public isReadOnly: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private clientService: ClientService,
    private salonService: SalonService,
    private loadingCtrl: LoadingController,
    private alertController: AlertController,
    private actionSheetController: ActionSheetController,
    private platform: Platform,
    private router: Router,
    private location: Location,
    private changeDetectorRef: ChangeDetectorRef,
    private navigationStateService: NavigationStateService
  ) {
    this.navigationStateSubscription = this.navigationStateService.getState().subscribe((state) => {
      this.clientID = state.clientID;
      if (state.bookingID != null && state.bookingID != 0)
        this.bookingID = state.bookingID;
    });
  }

  ngOnInit() {
    this.isLoading = true;
    this.tab = 'client-info';
    this.subscriptions = this.platform.resize.subscribe(() => {
      this.matchHeights()
    });

    this.platform.ready().then(() => {
      this.windowWidth = this.platform.width()
    })

    if (this.client) this.clientID = this.client.id;
    this.loadClient()
    this.isReadOnly = this.salonService.getIsReadOnly();
  }

  public ngAfterViewChecked() {
    if (this.firstLoaded)
      this.matchHeights();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.navigationStateSubscription.unsubscribe();
  }

  public matchHeights() {

    const clientPicker = document.getElementsByClassName(
      'smr-client-list'
    ) as HTMLCollectionOf<HTMLElement>;

    const clientDetailHeader = document.getElementsByClassName(
      'smr-client-detail-header'
    ) as HTMLCollectionOf<HTMLElement>;
    const clientDetail = document.getElementsByClassName(
      'smr-client-detail-content'
    ) as HTMLCollectionOf<HTMLElement>;

    const clientDetailFooter = document.getElementsByClassName(
      'smr-client-detail-footer'
    ) as HTMLCollectionOf<HTMLElement>;

    if (clientPicker[0] && clientDetailHeader[0] && clientDetailHeader[0].scrollHeight > 0) {
      const height = clientPicker[0].scrollHeight - clientDetailHeader[0].scrollHeight - clientDetailFooter[0].scrollHeight
      clientDetail[0].style.height = `${height}px`;
      this.firstLoaded = false;
    }
  }


  back() {
    this.location.back()
  }

  loadClient() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingClientDetails = false;
    this.clientService.loadClientInfo(this.clientID).subscribe(client => { this.client = client; this.isLoading = false })
  }


  public loadBookings() {
    this.isLoadingPastBookings = true;
    this.errorOccurredWhileLoadingPastBookings = false;
    this.clientService.getClientBookings(this.client.getID())
      .subscribe({
        next: (bookings: List<Booking>) => {
          this.isLoadingPastBookings = false;
          this.pastBookings = bookings.filter((booking) => {

            // if (booking.getId() === this.booking.getId()) {
            //   return false;
            // }

            if (booking.photos.count() === 0 && booking.beforePhotos.count() === 0 && booking.afterPhotos.count() === 0) {
              return false;
            }

            return true;
          }).toList();

          // this.pastBookings = bookings;
          this.changeDetectorRef.markForCheck();
        },
        error: (err) => {
          this.isLoadingPastBookings = false;
          this.errorOccurredWhileLoadingPastBookings = true;
          this.changeDetectorRef.markForCheck();
        }
      });
  }

  public updateClient(event) {
    this.clientLoaded.emit(event)
  }

  public async edit() {
    if (this.isReadOnly) {
      return;
    }
    const modal = await this.modalCtrl.create({
      component: ClientFormPageComponent,
      componentProps: {
        client: this.client, modal: true, saveButtonText: 'Save & Continue'
      }
    })

    modal.present();

    modal.onWillDismiss().then((data) => {
      if (data.data) {
        let res = new Client(data.data.client)
        this.client = res;
        if (this.platform.is('mobile')) {
          this.clientService.editClientList(this.client);
        }
        else {
          this.clientEdited.emit(this.client);
        }
      }
    })
  }
  public async onClientDelete() {
    if (this.isReadOnly) {
      return;
    }
    const actionSheet = await this.actionSheetController.create({
      header: 'Are you sure you want to delete this client?',
      buttons: [
        {
          text: 'Delete',
          role: 'destructive',
          handler: () => {
            this.clientService.deleteClient(this.client)
              .subscribe({
                next: (event) => {
                  actionSheet.dismiss()
                  if (this.platform.is('mobile')) {
                    this.router.navigate(['clients', { clientId: this.client.id }]);
                  }
                  else {
                    this.clientDeleted.emit(this.client.id);
                  }
                },
                error: async (e) => {
                  const alert = await this.alertController.create(Utilities.getDefaultErrorMessageConfig())
                  alert.present();
                }
              });
            return false;
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });
    actionSheet.present();
  }
  public async onClientMerge() {
    if (this.isReadOnly) {
      return;
    }

    const modal = await this.modalCtrl.create({
      component: ClientPickerComponent,
      componentProps: {
        ignoreClient: this.client,
        title: "Select a client to merge into",
        searchTerm: this.client.getFirstName()
      }
    });
    modal.onDidDismiss().then(async (data: any) => {
      if (data.data) {
        const mergeModal = await this.modalCtrl.create({
          component: ClientMergeComponent,
          componentProps: {
            client: data.data,
            mergeFrom: this.client,
            modal: true,
          }
        });
        mergeModal.onDidDismiss().then(({ data }) => {
          if (data) {
            this.clientMerged.emit(this.client);
          }
        });
        mergeModal.present();
      }
    });
    modal.present();
  }
  setProfilePhoto(profilePhoto: string) {
    this.client.setProfilePhoto(profilePhoto);
    this.profilePhoto.emit({ id: this.client.getID(), profilePhoto: profilePhoto });
  }

}
